// removed by extract-text-webpack-plugin
module.exports = {"notification":"eNJgAGE"};


//////////////////
// WEBPACK FOOTER
// ./template/components/IconNotification/index.css
// module id = ./template/components/IconNotification/index.css
// module chunks = client.sitechrome